import {AppMenuItem} from '../../shared/interfaces/menu-config-interface';
import {TipoPuntoVentaEnum} from '../../shared/enums/tipo-punto-venta-enum';
import {AmbienteEnum} from '../../shared/enums/ambiente-enum';
import {SociedadEnum} from '../../shared/enums/sociedad-enum';
import {MENU_PERMISSIONS} from '../constants/menu-permissions.constant';

export const DEVOLUCIONES_MENU: AppMenuItem = {
  "label": "Devoluciones",
  "visible": true,
  "children": [
    {
      "ambientes": [
        AmbienteEnum.Desarrollo,
        AmbienteEnum.Calidad,
        AmbienteEnum.Capacitacion,
        AmbienteEnum.Produccion
      ],
      "sociedades": [
        SociedadEnum.SC
      ],
      "label": "Consulta",
      "route": "devolucion/consulta-devoluciones-pendientes",
      "proceso": MENU_PERMISSIONS.consultaDevoluciones,
      "tipoPuntoVenta": [
        TipoPuntoVentaEnum.Corporativo
      ],
      "visible": true
    }
  ]
};
